import { createContext } from "react";

interface UserContextType {
  userId: string;
  userName: string | null;
  setUserName: (name: string) => void;
  isLoading: boolean;
}

export const UserContext = createContext<UserContextType | undefined>(undefined);
